import React from 'react';
import PropTypes from 'prop-types';
import { RectShape, TextRow } from '@thd-olt-component-react/loading-placeholder';
import { Row } from '@thd-olt-component-react/grid';
import '../../styles/dimension.scss';

const DimensionPlaceholder = () => {
  return (
    <div className="dimension">
      <Row>
        <RectShape style={{ width: '55px', height: '20px', margin: '5px' }} color="#E0E0E0" />
        {['70', '70', '70'].map((col, index) => {
          return (
            <Row key={`filter-fast-${index}`} style={{ display: 'flex', width: '100%' }}>
              <RectShape style={{ width: '23px', height: '23px', margin: '5px' }} color="#E0E0E0" />
              <TextRow style={{ width: `${col}%` }} color="#E0E0E0" />
            </Row>
          );
        })}
      </Row>
    </div>
  );
};

const DimensionsPlaceholder = ({ numOf }) => {
  return (
    <div className="results-dimensions" data-component="DimensionsPlaceholder">
      {[...Array(numOf)].map((n, i) => <DimensionPlaceholder key={i} />)}
    </div>
  );
};

DimensionsPlaceholder.propTypes = {
  numOf: PropTypes.number
};

DimensionsPlaceholder.defaultProps = {
  numOf: 3
};

DimensionsPlaceholder.displayName = 'DimensionsPlaceholder';

export { DimensionsPlaceholder };